import React, { useState } from 'react';

const AuthForm = ({
  mode = 'login',
  onSubmit,
  forgotLabel,
  onForgotPassword,
  submitLabel,
  providers,
  isSubmitting = false,
  labels = {},
}) => {
  const l = {
    firstName: 'First Name',
    firstNamePlaceholder: 'First name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Last name',
    username: 'Username',
    usernamePlaceholder: 'Choose a username',
    emailAddress: 'Email Address',
    emailPlaceholder: 'yourname@example.com',
    emailOrUsername: 'Email or Username',
    emailOrUsernamePlaceholder: 'your email or username',
    password: 'Password',
    ...labels,
  };
  const [showPassword, setShowPassword] = useState(false);
  const [formValues, setFormValues] = useState({
    identifier: '',
    firstName: '',
    lastName: '',
    login: '',
    email: '',
    password: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (onSubmit) {
      onSubmit(formValues);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      {mode === 'register' ? (
        <>
          <div className="auth-fields-grid">
            <div className="auth-field-group">
              <label htmlFor="firstName">{l.firstName}</label>
              <input
                id="firstName"
                type="text"
                name="firstName"
                autoComplete="given-name"
                placeholder={l.firstNamePlaceholder}
                value={formValues.firstName}
                onChange={handleChange}
                disabled={isSubmitting}
                required
              />
            </div>
            <div className="auth-field-group">
              <label htmlFor="lastName">{l.lastName}</label>
              <input
                id="lastName"
                type="text"
                name="lastName"
                autoComplete="family-name"
                placeholder={l.lastNamePlaceholder}
                value={formValues.lastName}
                onChange={handleChange}
                disabled={isSubmitting}
                required
              />
            </div>
          </div>
          <div className="auth-field-group">
            <label htmlFor="login">Username</label>
            <input
              id="login"
              type="text"
              name="login"
              autoComplete="username"
              placeholder="Choose a username"
              value={formValues.login}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
          <div className="auth-field-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              name="email"
              autoComplete="email"
              placeholder="yourname@example.com"
              value={formValues.email}
              onChange={handleChange}
              disabled={isSubmitting}
              required
            />
          </div>
        </>
      ) : (
        <div className="auth-field-group">
          <label htmlFor="identifier">{l.emailOrUsername}</label>
          <input
            id="identifier"
            type="text"
            name="identifier"
            autoComplete="username"
            placeholder={l.emailOrUsernamePlaceholder}
            value={formValues.identifier}
            onChange={handleChange}
            disabled={isSubmitting}
            required
          />
        </div>
      )}
      <div className="auth-field-group">
        <div className="auth-field-label">
          <label htmlFor="password">{l.password}</label>
          {forgotLabel ? (
            <button
              type="button"
              onClick={onForgotPassword}
              className="auth-forgot"
              aria-label="Forgot password"
              disabled={isSubmitting}
            >
              {forgotLabel}
            </button>
          ) : null}
        </div>
        <div className="auth-password-wrapper">
          <input
            id="password"
            type={showPassword ? 'text' : 'password'}
            name="password"
            autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
            placeholder="********"
            value={formValues.password}
            onChange={handleChange}
            disabled={isSubmitting}
            required
          />
          <button
            type="button"
            className="auth-password-toggle"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            onClick={() => setShowPassword((v) => !v)}
            tabIndex={-1}
          >
            <span className="material-symbols-rounded" aria-hidden="true">
              {showPassword ? 'visibility_off' : 'visibility'}
            </span>
          </button>
        </div>
      </div>
      <button type="submit" className="auth-submit" disabled={isSubmitting}>
        {submitLabel}
      </button>
      {providers?.length ? (
        <div className="auth-divider">
          <span />
          <p>OR</p>
          <span />
        </div>
      ) : null}
      {providers?.length ? (
        <div className="auth-provider-list">
          {providers.map((provider) => (
            <button
              type="button"
              key={provider.id}
              className="auth-provider-button"
              onClick={() => provider.onSelect?.(provider.id)}
              disabled={isSubmitting}
            >
              {provider.icon}
              <span>{provider.label}</span>
            </button>
          ))}
        </div>
      ) : null}
    </form>
  );
};

export default AuthForm;
